import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Code from './code';
import Phone from './phone';

import { Modal } from '../components/global/modal';
import { isMobile } from '../../utils/mobile';
import logo from '../../assets/img/next/logo.svg';

const Auth = ({ isOpen, onClose, auth: { phone }, user, denyRedirect = false, connectToBotFn }) => {
  const [RenderComponent, setRenderComponent] = useState(Phone);
  const history = useHistory();

  useEffect(() => {
    if (phone) {
      setRenderComponent(Code);
    }
  }, [phone]);

  const handleChangePhone = () => {
    setRenderComponent(Phone);
  };

  const isApp = !!window.ReactNativeWebView;
  const forceAuth = !user?.token && !!(isApp ? user?.edniproPopup?.app : user?.edniproPopup?.web);

  const wasForceAuth = useRef(false);
  useEffect(() => {
    if (forceAuth) {
      wasForceAuth.current = true;
    }
    if (wasForceAuth.current && user?.token) {
      history.push('/');
    }
  }, [forceAuth, user?.token, history]);

  const effectiveIsOpen = forceAuth || isOpen;

  const dialogClass = [
    'modal-dialog',
    'auth',
    isMobile() ? 'auth--mobile-fullscreen' : '',
    forceAuth ? 'auth--force' : '',
  ].filter(Boolean).join(' ');

  return (
    <Modal isOpen={effectiveIsOpen}>
      <div className={dialogClass} role="document">
        <div className="modal-content">
          {forceAuth ? (
            <div className="auth__force-welcome">
              <h2 className="auth__force-title">
                Вітаємо вас в застосунку<br />
                <span>Likari24/7</span>
              </h2>
              <p className="auth__force-subtitle">
                Для продовження роботи необхідно авторизуватись
              </p>
            </div>
          ) : (
            <>
              <p className="modal_title">Авторизація</p>
              <button onClick={onClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </>
          )}

          <div className={forceAuth ? 'auth__force-form' : ''}>
            <RenderComponent
              onClose={forceAuth ? undefined : onClose}
              denyRedirect={forceAuth ? true : denyRedirect}
              connectToBotFn={connectToBotFn}
              onChangePhone={RenderComponent === Code ? handleChangePhone : undefined}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Auth;
